
import { React } from "react";
import ReactECharts from "echarts-for-react"; // or var ReactECharts = require('echarts-for-react');

// Import the echarts core module, which provides the necessary interfaces for using echarts.
import * as echarts from "echarts/core";

// Import charts, all with Chart suffix
import {
  // LineChart,
  // BarChart,
  // PieChart,
  // ScatterChart,
  // RadarChart,
  // MapChart,
  // TreeChart,
  // TreemapChart,
  // GraphChart,
  GaugeChart,
  // FunnelChart,
  // ParallelChart,
  // SankeyChart,
  // BoxplotChart,
  // CandlestickChart,
  // EffectScatterChart,
  // LinesChart,
  // HeatmapChart,
  // PictorialBarChart,
  // ThemeRiverChart,
  // SunburstChart,
  // CustomChart,
} from "echarts/charts";
// import components, all suffixed with Component
import {
  // GridSimpleComponent,
  GridComponent,
  // PolarComponent,
  // RadarComponent,
  // GeoComponent,
  // SingleAxisComponent,
  // ParallelComponent,
  // CalendarComponent,
  // GraphicComponent,
  // ToolboxComponent,
  TooltipComponent,
  // AxisPointerComponent,
  // BrushComponent,
  TitleComponent,
  // TimelineComponent,
  // MarkPointComponent,
  // MarkLineComponent,
  // MarkAreaComponent,
  // LegendComponent,
  // LegendScrollComponent,
  // LegendPlainComponent,
  // DataZoomComponent,
  // DataZoomInsideComponent,
  // DataZoomSliderComponent,
  // VisualMapComponent,
  // VisualMapContinuousComponent,
  // VisualMapPiecewiseComponent,
  // AriaComponent,
  // TransformComponent,
  // DatasetComponent,
} from "echarts/components";
// Import renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
import {
  CanvasRenderer,
  // SVGRenderer,
} from "echarts/renderers";

const Donut = (props) => {
  // Register the required components
  echarts.registerTheme("my_theme", {
    backgroundColor: "#f4cccc",
  });

  // let colorsArray = props.data.map(function (obj) {
  //   return obj.color;
  // });
  // let colorsArray = ['#73C0DE', '#EE6666'];
  let colorsArray = ["#087A3E", "#FCC644", "#E3324C"];

  echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    GaugeChart,
    CanvasRenderer,
  ]);
  const options = () => ({
    tooltip: {
      trigger: "item",
    },
    series: [
      {
        //name: props.siteName?props.siteName:"Site",
        type: 'pie',
        radius: [0, '50%'],
        label: {
          fontSize: 14,
          color: "black",
          fontWeight: "bold",
          formatter: "{c}",
          position: "center",
          show: true,
          borderRadius: "100%",
          padding: [4, 4, 4, 4],
          fontFamily: "JioType",
          rich: {
            a: {
              color: "red",
              lineHeight: 10,
              fontSize: 12,
            },
            x: {
              fontSize: "1em",
              fontFamily: "Montserrat",
              borderColor: "#449933",
              // borderRadius: 4,
              fontweight: "bold",
              fontStyle: "bold",
            },
          },
        },
        labelLine: {
          show: false
        },
        color: ["#FFFFFF"],
        emphasis: {
          disabled: true,
        },
        data: [
          { value: props.idle+props.fault+props.charging, name: 'Total' }
        ]
      },
      {
        //name: props.siteName?props.siteName:"Site",
        type: "pie",
        radius: ["50%", "90%"],
        avoidLabelOverlap: true,
        label: {
          show: false,         
        },
        labelLine: {
          show: false,
        },
        color: colorsArray,
        data1: props.data,
        data: [
          { value: props.idle, name: "Available" },
          { value: props.charging, name: "Charging" },
          { value: props.fault, name: "Fault" },
        ],
      },
    ],
  });

  return (
    <ReactECharts
      echarts={echarts}
      //option={this.getOption()}
      // notMerge={true}
      // lazyUpdate={true}
      theme={"theme_name"}
      //onChartReady={this.onChartReadyCallback}
      //onEvents={EventsDict}
      style={{
        height: "60px",
        width: "130px",
        position: "absolute",  
        transform: "translate(-50%, -50%)",
      }}
      // opts={{renderer: 'svg'}} // use svg to render the chart.
      option={options()}
    />
  );
};

export default Donut;
